import { render, staticRenderFns } from "./edit-button.component.vue?vue&type=template&id=57ffed6e&scoped=true&"
import script from "./edit-button.component.vue?vue&type=script&lang=ts&"
export * from "./edit-button.component.vue?vue&type=script&lang=ts&"
import style0 from "./edit-button.component.vue?vue&type=style&index=0&id=57ffed6e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ffed6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
